var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7192 4.24996H20V3C20 2.44772 19.5523 2 19 2H17C16.4477 2 16 2.44772 16 3V2C16 1.44772 15.5523 1 15 1H13C12.4477 1 12 1.44772 12 2V3C12 2.44772 11.5523 2 11 2H9C8.44772 2 8 2.44772 8 3V4.24996H6.01481L5.93539 3.85287C5.75894 2.97058 5.12325 2.25049 4.26966 1.96596L2.23713 1.28845C1.84417 1.15746 1.41943 1.36983 1.28845 1.76279C1.15746 2.15575 1.36983 2.58049 1.76279 2.71147L3.79532 3.38898C4.13825 3.50329 4.39363 3.79259 4.46452 4.14705L6.74297 15.5393C7.00005 16.8247 8.12869 17.75 9.43957 17.75H18C18.4142 17.75 18.75 17.4142 18.75 17C18.75 16.5857 18.4142 16.25 18 16.25H9.43957C8.84372 16.25 8.3307 15.8294 8.21384 15.2451L7.91481 13.75H18.4384C19.7003 13.75 20.8002 12.8911 21.1063 11.6669L22.4169 6.4244C22.6931 5.31989 21.8577 4.24996 20.7192 4.24996Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 20.5C11 21.3284 10.3284 22 9.5 22C8.67157 22 8 21.3284 8 20.5C8 19.6716 8.67157 19 9.5 19C10.3284 19 11 19.6716 11 20.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20.5C18 21.3284 17.3284 22 16.5 22C15.6716 22 15 21.3284 15 20.5C15 19.6716 15.6716 19 16.5 19C17.3284 19 18 19.6716 18 20.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartFull);
export default __webpack_public_path__ + "static/media/cart-full.097308c28629d950014534d9c584df3e.svg";
export { ForwardRef as ReactComponent };